export interface Report {
  id: string;
  title: string;
  type: 'engin' | 'sensor' | 'door';
  icon: string;
  description: string;
  createdAt: string;
  filePath?: string;
  status: 'completed' | 'pending' | 'error';
}

export interface ReportType {
  title: string;
  icon: string;
  description: string;
  type: 'engin' | 'sensor' | 'door';
}

// Mock data for existing reports - Based on HTML template structure
export const fakeReports: Report[] = [
  {
    id: 'RPT-2024-001',
    title: 'Analyse Entrepôt Principal - Octobre 2024',
    type: 'sensor',
    icon: 'fa-warehouse',
    description: 'Rapport complet des capteurs BC57290288E7, AC45120199F2 et DF78340567A1 - Période du 01/10 au 15/10/2024',
    createdAt: '2024-10-15T14:30:00Z',
    filePath: '/reports/entrepot-principal-oct-2024.pdf',
    status: 'completed'
  },
  {
    id: 'RPT-2024-002',
    title: 'Monitoring Zone Froide - Septembre 2024',
    type: 'sensor',
    icon: 'fa-snowflake',
    description: 'Surveillance température/humidité capteur BC57290288E7 - 47 dépassements détectés',
    createdAt: '2024-09-30T09:15:00Z',
    filePath: '/reports/zone-froide-sept-2024.pdf',
    status: 'completed'
  },
  {
    id: 'RPT-2024-003',
    title: 'Rapport Mensuel Multi-Capteurs - Août 2024',
    type: 'sensor',
    icon: 'fa-chart-line',
    description: 'Analyse comparative de 8 capteurs - Températures, humidité et alertes sur 31 jours',
    createdAt: '2024-08-31T18:45:00Z',
    filePath: '/reports/multi-capteurs-aout-2024.pdf',
    status: 'completed'
  },
  {
    id: 'RPT-2024-004',
    title: 'Audit Capteurs Laboratoire - Octobre 2024',
    type: 'sensor',
    icon: 'fa-flask',
    description: 'Contrôle qualité capteurs AC45120199F2 et DF78340567A1 - Conformité réglementaire',
    createdAt: '2024-10-12T11:20:00Z',
    status: 'pending'
  },
  {
    id: 'RPT-2024-005',
    title: 'Surveillance Batterie Critique - Octobre 2024',
    type: 'sensor',
    icon: 'fa-battery-quarter',
    description: 'Alerte maintenance - 3 capteurs sous 25% de batterie nécessitent intervention',
    createdAt: '2024-10-14T16:00:00Z',
    filePath: '/reports/batterie-critique-oct-2024.pdf',
    status: 'completed'
  },
  {
    id: 'RPT-2024-006',
    title: 'Analyse Dépassements Température - Juillet 2024',
    type: 'sensor',
    icon: 'fa-thermometer-full',
    description: 'Étude des pics de température - 156 dépassements sur capteur BC57290288E7',
    createdAt: '2024-07-31T13:30:00Z',
    filePath: '/reports/depassements-temp-juillet-2024.pdf',
    status: 'completed'
  },
  {
    id: 'RPT-2024-007',
    title: 'Rapport Hebdomadaire Entrepôt B - Octobre 2024',
    type: 'sensor',
    icon: 'fa-calendar-week',
    description: 'Suivi 7 jours capteurs DF78340567A1 - Stabilité température et humidité optimale',
    createdAt: '2024-10-13T08:45:00Z',
    filePath: '/reports/hebdo-entrepot-b-oct-2024.pdf',
    status: 'completed'
  },
  {
    id: 'RPT-2024-008',
    title: 'Diagnostic Capteur Défaillant - Octobre 2024',
    type: 'sensor',
    icon: 'fa-exclamation-triangle',
    description: 'Analyse panne capteur AC45120199F2 - Perte de signal et données incohérentes',
    createdAt: '2024-10-11T15:20:00Z',
    status: 'error'
  },
  {
    id: 'RPT-2024-009',
    title: 'Bilan Trimestriel Q3 2024 - Multi-Sites',
    type: 'sensor',
    icon: 'fa-building',
    description: 'Synthèse 3 mois - 15 capteurs, 2.3M mesures, 89% disponibilité moyenne',
    createdAt: '2024-09-30T17:00:00Z',
    filePath: '/reports/bilan-q3-2024.pdf',
    status: 'completed'
  },
  {
    id: 'RPT-2024-010',
    title: 'Export Données Brutes - Octobre 2024',
    type: 'sensor',
    icon: 'fa-database',
    description: 'Export CSV complet - 45,000 mesures capteur BC57290288E7 pour analyse externe',
    createdAt: '2024-10-10T10:15:00Z',
    filePath: '/reports/export-donnees-oct-2024.csv',
    status: 'completed'
  }
];

// Available report types
export const reportTypes: ReportType[] = [
  {
    title: 'Engin',
    icon: 'fa-tractor',
    description: 'Créer un rapport sur les engins',
    type: 'engin'
  },
  {
    title: 'Capteurs',
    icon: 'fa-thermometer-half',
    description: 'Créer un rapport sur les capteurs',
    type: 'sensor'
  },
  {
    title: 'Portes',
    icon: 'fa-door-open',
    description: 'Créer un rapport sur les portes',
    type: 'door'
  }
];
